import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, useMemo } from 'react';
import cn from 'classnames';
import { Badge, Button, IconButton, TextButton, Typography } from 'seagull';
import { ChevronLeft, Download } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { getAgreementPdfUrl } from '~/business-logic/relationshipLogic';
import { useIoContext, useStore } from '~/contexts';
import { relationshipModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import BrandingControllers from '../clientOb/BrandingControllers/BrandingControllers';
import { reasonToText } from '../clientOb/ClientOnboarding.utils';
import { OverrideBranding } from '../clientOb/CobBrandingContext';
import { useCobConfig } from '../clientOb/CobConfigContext';
import { useResponsive } from '../contexts';
import { FooterErrorMessage } from './FooterErrorMessage';
import styles from './StepPage.module.scss';
import { TextBox } from './TextBox';
export const GetStepPageTestIds = (testId)=>getTestIds(testId);
export function StepPage(param) {
    let { children, header, primaryBtn, onBackBtnClick, showError, disabledReason, contentClassName, errorMessage, showDownloadAsPDFButton = false, disableDownloadAsPDFButton = false, testId, withinFooter } = param;
    var _primaryBtn_props_testId;
    const worksAt = useStore(selectors.user.business);
    const { isMobile, isDesktop } = useResponsive();
    const { relationship, isSetupBrand } = useCobConfig();
    const { openNewTab } = useIoContext();
    const pdfHost = useStore(selectors.pdfHost);
    const { StepPageTestIds } = useMemo(()=>GetStepPageTestIds(testId), [
        testId
    ]);
    const onDownloadPDF = ()=>{
        openNewTab(getAgreementPdfUrl(relationshipModel.id(relationship), pdfHost));
    };
    if (primaryBtn.type === Button) {
        primaryBtn = /*#__PURE__*/ cloneElement(primaryBtn, {
            fluid: true
        });
    }
    primaryBtn = /*#__PURE__*/ cloneElement(primaryBtn, {
        testId: (_primaryBtn_props_testId = primaryBtn.props.testId) !== null && _primaryBtn_props_testId !== void 0 ? _primaryBtn_props_testId : StepPageTestIds.NextButton()
    });
    const wrappedPrimaryBtn = isDesktop ? /*#__PURE__*/ _jsx("div", {
        className: styles.ctaWrapper,
        children: primaryBtn
    }) : primaryBtn;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": StepPageTestIds.Root(),
        className: cn(styles.root, {
            [styles.mobile]: isMobile,
            [styles.desktop]: isDesktop
        }),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.headerAndContent,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.header,
                        children: /*#__PURE__*/ _jsxs(TextBox, {
                            className: styles.headerTextBox,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.title,
                                    children: [
                                        isDesktop && onBackBtnClick && /*#__PURE__*/ _jsx(IconButton, {
                                            skin: "transparent",
                                            onClick: onBackBtnClick,
                                            testId: StepPageTestIds.BackButton(),
                                            children: /*#__PURE__*/ _jsx(ChevronLeft, {})
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: isMobile ? 'h6' : 'h4',
                                            weight: "normal",
                                            testId: StepPageTestIds.Header(),
                                            children: header
                                        }),
                                        relationship.isSample && /*#__PURE__*/ _jsx(Badge, {
                                            outlined: true,
                                            children: "Test agreement"
                                        })
                                    ]
                                }),
                                showDownloadAsPDFButton && /*#__PURE__*/ _jsx(TextButton, {
                                    onClick: onDownloadPDF,
                                    className: styles.downloadButton,
                                    prefixIcon: /*#__PURE__*/ _jsx(Download, {
                                        size: 16
                                    }),
                                    underline: "none",
                                    variant: "paragraph2",
                                    weight: "light",
                                    testId: StepPageTestIds.DownloadPdf(),
                                    skin: "secondary",
                                    disabled: disableDownloadAsPDFButton,
                                    children: "Download as PDF"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.contentWrapper, contentClassName),
                        "data-testid": StepPageTestIds.Content(),
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.content,
                            children: children
                        })
                    })
                ]
            }),
            isSetupBrand && worksAt && /*#__PURE__*/ _jsx(OverrideBranding, {
                className: styles.setupBrandContainer,
                testId: "setup-brand-section",
                children: /*#__PURE__*/ _jsx(BrandingControllers, {
                    worksAt: worksAt
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.footer,
                children: [
                    withinFooter && /*#__PURE__*/ _jsx("div", {
                        className: styles.withinFooter,
                        children: withinFooter
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.primaryBtnContainer,
                        children: [
                            errorMessage ? /*#__PURE__*/ _jsx(FooterErrorMessage, {
                                vertical: isMobile,
                                showError: showError !== null && showError !== void 0 ? showError : false,
                                errorMessage: errorMessage,
                                testId: StepPageTestIds.Error(),
                                children: wrappedPrimaryBtn
                            }) : wrappedPrimaryBtn,
                            disabledReason && /*#__PURE__*/ _jsx(Typography, {
                                testId: "disabled-reason-".concat(disabledReason),
                                className: styles.disabledReason,
                                children: reasonToText[disabledReason]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
